import { useEffect, useMemo } from 'react';
import Pubnub from 'pubnub';

export default function useRestart(pubnubClient: Pubnub, logger: Logger): void {
  // We need to memoize the { message: <handler> } object because pubnub removes
  // listeners by reference of the object rather than the callback.
  const handleMessage = useMemo(
    () => ({
      message: (event: Pubnub.MessageEvent) => {
        if (
          event.message &&
          typeof event.message === 'object' &&
          event.message?.body?.value === 'restart'
        ) {
          logger.info(`Received 'restart' message from pubnub, reloading`);
          // NOTE: Reloading here will cause the above log message to never be flushed.
          window.location.reload();
        }
      },
    }),
    [logger],
  );

  useEffect(() => {
    pubnubClient.addListener(handleMessage);

    return () => {
      pubnubClient.removeListener(handleMessage);
    };
  }, [pubnubClient, handleMessage]);
}
